<template>
  <div class="home-index">
    <el-carousel :interval="5000" arrow="always">
      <el-carousel-item v-for="item in bannerList" :key="item.name">
        <a v-if="item.link" :href="item.link" target="_blank">
          <img :src="item.img" :alt="item.name" class="banner-img" >
        </a>
        <img v-else :src="item.img" :alt="item.name" class="banner-img">
      </el-carousel-item>
    </el-carousel>
    <!-- 产品及服务 -->
    <div class="brand-list">
      <div class="defult_title">
        <h1>{{language === 'E' ? 'PRODUCT FAMILY' : '产品及服务'}}</h1>
        <p>{{language === 'E' ? '产品及服务' : 'PRODUCT FAMILY'}}</p>
      </div>
      <div class="defult_width">
          <el-row :gutter="20">
            <el-col :span="12" v-for="(item, index) in brandList" :key="item.name">
              <div class="grid-content bg-purple list" @click="linkProductCenter(index)">
                <router-link :to="`/ProductCenter?type=${index}`" v-if="(index+1)%2 == 0" class="first">
                  <img :src="item.img" :alt="item.name">
                  <h5>
                    {{ item.name }}
                  </h5>
                  <p>
                    {{ item.detail}}
                  </p>
                </router-link>
                <router-link :to="`/ProductCenter?type=${index}`" v-else class="second">
                  <img :src="item.img" :alt="item.name">
                  <h5>
                    {{ item.name }}
                  </h5>
                  <p>
                    {{ item.detail}}
                  </p>
                </router-link>
              </div>
            </el-col>
          </el-row>
      </div>
    </div>
    <!-- 案例展示 -->
    <div class="product-list">
      <div class="defult_title">
        <h1>{{language === 'E' ? 'SUCCESS CASES' : '案例展示'}}</h1>
        <p>{{language === 'E' ? '案例展示' : 'SUCCESS CASES'}}</p>
      </div>
      <el-row class="defult_width">
        <el-col :span="6" v-for="item in coreValuesList" :key="item.name">
          <div class="grid-content bg-purple list">
            <router-link  :to="`sharingDetail/${item.id}`">
              <img :src="item.img" :alt="item.name">
              <h5>
                {{ item.name }}
              </h5>
              <p>
                {{ item.detail}}
              </p>
            </router-link>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 热销主题 -->
     <!-- <div class="business-list">
      <div class="defult_title">
        <h1>热销主题</h1>
        <p>HOT SELLING THEME</p>
      </div>
      <el-row class="defult_width">
        <el-col :span="8" v-for="item in businessList" :key="item.name">
          <div class="grid-content bg-purple list">
            <h5>
              <span>
                {{ item.name }}
              </span>
            </h5>
            <ul>
              <li v-for="(li, index) in item.list" :key="li.label">
                <router-link v-if="li.id !== undefined" :to="`productDetail/${li.id}/${li.type}`">
                  <i class="el-icon-message"></i>
                  {{ li.label }}
                </router-link>
                <span v-else-if="li.type && index == 2" @click="linkProductCenter(li.type)" class="lable">
                  <i class="el-icon-message"></i>
                  {{ li.label }}
                </span>
                <span v-else>
                  <i class="el-icon-message"></i>
                  {{ li.label }}
                </span>
                </li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </div> -->
    <!-- 新闻动态 -->
    <div class="news-list">
      <div class="defult_title">
        <h1>{{language === 'E' ? 'NEWS INFORMATION' : '新闻动态'}}</h1>
        <p>{{language === 'E' ? '新闻动态' : 'NEWS INFORMATION'}}</p>
      </div>
       <el-row class="defult_width">
        <el-col :span="16">
          <el-row>
            <ul class="news-list-lable" v-if="language === 'E'">
              <li v-for="(item,index) in EnewsTitle" :key="item" :class="newsIndex == index ? 'news-active' : ''" @mousemove="newsIndex = index">{{ item }}</li>
            </ul>
            <ul class="news-list-lable" v-else>
              <li v-for="(item,index) in newsTitle" :key="item" :class="newsIndex == index ? 'news-active' : ''" @mousemove="newsIndex = index">{{ item }}</li>
            </ul>
            <el-row class="news-box">
              <ul>
                <li v-for="(item, index) in newsIndex == 0 ? newsList : (newsIndex == 1 ?  companyNewsList :  sharingList)" :key="item.name" v-if="index < 3">
                   <router-link :to="newsIndex == 0 ? `newsDetail/${item.id}` :(newsIndex == 1 ? `aboutMeDetail/${item.id}` : `sharingDetail/${item.id}`) ">
                    <div class="time">
                      <p>
                        {{ item.time.month }}
                      </p>
                      <span>
                        {{ item.time.year }}
                      </span>
                    </div>
                    <div class="list">
                        <h5>
                        {{ item.name }}
                        </h5>
                        <p>
                          {{ (item.detail).substring(0, 180) + '...' }}
                        </p>
                    </div>
                  </router-link>
                </li>
              </ul>
              <router-link  class="more-btn" :to="newsIndex == 0 ? `IndustryNews`: `sharingList`" v-if="newsIndex == 0 || newsIndex == 2">More&nbsp;&nbsp;></router-link>
            </el-row>
          </el-row>
        </el-col>
        <el-col :span="8" class="recommend">
           <div>
              <router-link  v-for="item in recommend" :style="'background-image:url(' + item.img + ')'" :key="item.name" :to="`newsDetail/${item.id}`">
                <span>{{ item.name }}</span>
              </router-link>
           </div>
        </el-col>
       </el-row>
    </div>
    <!-- 合作伙伴 -->
     <div class="partner-list">
      <div class="defult_title">
        <h1>{{language === 'E' ? 'COOPERATIVE PARTNER' : '合作伙伴'}}</h1>
        <p>{{language === 'E' ? '合作伙伴' : 'COOPERATIVE PARTNER'}}</p>
      </div>
      <el-row class="defult_width">
        <el-col v-for="item in partnerList" :key="item.name">
          <div class="grid-content bg-purple list">
            <a :href="item.link" target="_blank">
              <img :src="item.img" :alt="item.name">
            </a>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import index from '@/datas/index'
import news from '@/datas/news'
import sharing from '@/datas/sharing'
import Eindex from '@/EnglishData/index'
import Enews from '@/EnglishData/news'
import Esharing from '@/EnglishData/sharing'
export default {
  name: 'index',
  data () {
    const language = localStorage.getItem('language')
    let languageIndex = null
    let languageNews = null
    let languageSharing = null
    if (language && language === 'E') {
      languageIndex = Eindex
      languageNews = Enews
      languageSharing = Esharing
    } else {
      languageIndex = index
      languageNews = news
      languageSharing = sharing
    }
    const { bannerList, coreValuesList, company, partnerList, recommend, brandList, businessList } = languageIndex
    const { companyNewsList, newsList } = languageNews
    const { sharingList } = languageSharing
    return {
      bannerList, // banner列表
      coreValuesList, // 核心价值
      companyNewsList, // 公司新闻
      newsList, // 行业动态
      sharingList, // 行业技术
      company, // 公司相关
      partnerList, // 合作伙伴列表
      recommend, // 推荐
      brandList, // 国内外元器件
      businessList, // 热销主题列表
      newsIndex: 0, // 当前选中的新闻类型列表
      newsTitle: ['行业动态', '公司新闻'],
      EnewsTitle: ['Industry trends', 'Company news'],
      language
    }
  },
  created () {
  },
  methods: {
    linkTo (id) {
      this.$router.push({
        path: '/productsList',
        query: {
          id: id
        }
      })
    },
    linkProductCenter (type) {
      this.$router.push({
        path: '/ProductCenter',
        query: {
          type
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.home-index {
  .banner-img {
  width: 100%;
  height: 100%;
  }
  /deep/.el-main {
    padding: 0;
  }
  /deep/.el-carousel__container {
    height: 600px;
  }
  /deep/.el-carousel__arrow {
    width: 50px;
    height: 50px;
    font-size: 34px;
  }
  .product-list {
    background: #f7f7f7;
    padding: 40px 0;
  }
  .product-list {
    .list {
      width: 80%;
      img {
        width: 100%;
        margin: 0 0 20px;
        height: 180px;
      }
      h5 {
        font-size: 16px;
        color: #333;
        line-height: 40px;
      }
      p {
        font-size: 12px;
        color: #999;
        line-height: 24px;
        text-align: left;
        max-height: 120px;
        overflow: hidden;
      }
    }
  }
  .brand-list {
    padding: 20px 0;
    .el-col {
      .list {
        background: #0e5073;
        overflow: hidden;
        // width: 92%;
        margin: 0 auto 20px;
        // padding-right: 20px;
        .first {
          img {
            float: left;
            margin-right: 20px;
          }
        }
        .second {
            img {
            float: right;
            margin-left: 20px;
          }
        }
        h5 {
          padding: 20px 0;
          color: #fff;
          font-size: 16px;
          margin-left: -20px;
        }
        p {
          text-indent: 2em;
          color: #fff;
          font-size: 12px;
          line-height: 24px;
          padding: 0 20px;
          word-wrap: break-word;
          word-break: normal;
        }
      }
    }

  }
  .business-list {
    background: #f7f7f7;
    padding: 30px 0;
    .list {
      width: 92%;
      margin: 0 auto;
      h5 {
        text-align: left;
        border-bottom: 1px solid #e5e5e5;
        span {
          display: inline-block;
          padding: 15px 10px;
          border-bottom: 1px solid #1e50ae;
        }
      }
      ul {
        li {
          .lable {
            cursor: pointer;
          }
          a, span {
            display: block;
            line-height: 40px;
            border-bottom: 1px solid #e5e5e5;
            padding-left: 30px;
            position: relative;
            text-align: left;
            color: #666;
            i {
              position: absolute;
              left: 10px;
              top: 15px;
            }
          }
        }
      }
    }
  }
  .news-list {
    padding-top: 30px;
    min-height: 623px;
    background: #f7f7f7;
    .defult_width {
      padding-bottom: 40px;
    }
    .news-list-lable {
      width: 100%;
      border: none;
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      li {
        width: 45%;
        border: none;
        height: 50px;
        line-height: 50px;
        cursor: pointer;
        transition: all .5s;
        &:hover {
          background: #1e50ae;
          color: #fff;
        }
      }
      .news-active {
        background: #1e50ae;
        color: #fff;
      }
    }
    .news-box {
      li {
        a {
          display: block;
          padding: 20px 0;
          border-bottom: 1px solid #e5e5e5;
          overflow: hidden;
          .time {
            text-align: left;
            width: 14%;
            float: left;
            p {
              font-size: 30px;
              color: #4a4a4a;
            }
            span {
              color: #767676;

            }
          }
          .list {
            width: 86%;
            float: right;
            text-align: left;
            h5 {
              font-size: 18px;
              color: #4a4a4a;
              line-height: 30px;
            }
            p {
              line-height: 24px;
            }
          }
        }
      }
      .more-btn {
        line-height: 40px;
        color: #1e50ae;
        display: block;
        text-align: right;
        font-size: 18px;
      }

    }
    .recommend {
     div {
        a {
          width: 80%;
          margin-left: 20%;
          display: block;
          height: 200px;
          position: relative;
          background-position: center;
          background-size: cover;
          background-repeat: no-repeat;
          span {
            display: inline-block;
            width: 100%;
            height: 30px;
            line-height: 30px;
            color: #fff;
            background: rgba(0,0,0,.6);
            position: absolute;
            bottom: 0;
            left: 0;
          }
          &:last-child {
            margin-top: 20px;
          }
        }
     }

    }

  }
  .partner-list {
    padding: 40px 0;
    .el-col {
      width: 20%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .list {
        width: 100%;
        a {
          display: block;
          width: 80%;
          background: #fff;
          border-radius: 5px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            max-width: 70%;
            max-height: 70%;
          }
        }

      }
    }

  }
}

</style>



// WEBPACK FOOTER //
// src/view/index.vue